export default "__VITE_ASSET__vj2r9rcM__"